import unimeth from "../../../../assets/images/productos/unimetH/unimetH.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/unimetH/Mosaico - UH1.png";

import { useTranslation } from "react-i18next";

function UnimetH() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1]}
      datosTabla1={[
        [t("tensionNominal"), "kV", "17,5"],
        [t("corrienteNominal"), "A", "1.250 / 2.000 / 2.500"],
        [t("corrienteBreveDuracion"), "kA", "25 / 31,5"],
        [t("corrienteDinamica"), "kA", "63 / 78"],
        [t("nivelDeAislacion"), "kV", "38"],
        [t("tensionDeImpulso"), "kV", "95"],
        [t("frecuenciaNominal"), "Hz", "50 / 60"],
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "850"],
        [t("alto"), "mm", "3.000"],
        [t("profundidad"), "mm", "2.630"],
      ]}
      nombreProducto={"Unimet H"}
      fotoProducto={unimeth}
      descripcionProducto={
       t("unimetH.titulo_descripcion")
      }
      caracteristicas={[
        t("unimetH.bullet1"),
        t("unimetH.bullet2"),
        t("unimetH.bullet3"),
        t("unimetH.bullet4"),
        t("unimetH.bullet5"),
        t("unimetH.bullet6"),
        t("unimetH.bullet7"),
        t("unimetH.bullet8")        
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20Unimet%20H.pdf'}
    />
  );
}

export default UnimetH;
